import { render, staticRenderFns } from "./ArticleSegmentCreate.vue?vue&type=template&id=6dcad2ea"
import script from "./ArticleSegmentCreate.vue?vue&type=script&lang=js"
export * from "./ArticleSegmentCreate.vue?vue&type=script&lang=js"
import style0 from "./ArticleSegmentCreate.vue?vue&type=style&index=0&id=6dcad2ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports